import { css } from '@linaria/core';

import { ELEVATED_CONTAINER_CLASSNAME } from '../consts';

export const xsmall: string =
  `${ELEVATED_CONTAINER_CLASSNAME} ` +
  css`
    @layer alchemy {
      background-color: var(--al-color-bg);
      box-shadow: var(--al-shadow-xsmall);
    }
  `;

export const small: string =
  `${ELEVATED_CONTAINER_CLASSNAME} ` +
  css`
    @layer alchemy {
      background-color: var(--al-color-bg);
      box-shadow: var(--al-shadow-small);
    }
  `;

export const medium: string =
  `${ELEVATED_CONTAINER_CLASSNAME} ` +
  css`
    @layer alchemy {
      background-color: var(--al-color-bg);
      box-shadow: var(--al-shadow-medium);
    }
  `;

export const large: string =
  `${ELEVATED_CONTAINER_CLASSNAME} ` +
  css`
    @layer alchemy {
      background-color: var(--al-color-bg);
      box-shadow: var(--al-shadow-large);
    }
  `;
